.trigger-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.clear-button {
    display: flex;
    align-items: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 120ms ease-in-out;
}

.trigger-row:hover .clear-button,
.trigger-row:focus-within .clear-button {
    opacity: 1;
    pointer-events: auto;
}

.menu-container {
    position: absolute;
    z-index: 5;
    min-width: 200px;
    max-width: 300px;
    background: white;
    border-radius: 4px;
    box-shadow:
        0 0 0 1px hsla(0, 0%, 0%, 0.1),
        0 4px 11px hsla(0, 0%, 0%, 0.1);
    margin-top: 8px;
}

.menu-container ul {
    max-height: 300px;
    overflow-y: auto;
}
